import React, { useState, Fragment } from "react";
import {
  Button, Checkbox, Radio, Dialog, DialogActions, DialogContent, 
  DialogTitle, FormControlLabel, Box, Divider, Typography
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DoneIcon from "@mui/icons-material/Done";
import SearchFanpageForm from "./SearchFanpageForm";

const DialogSelectFanpages = ({
  listFanpages = [],
  handleChangeFanpage,
  fanpageSelected = [],
  autoSave = false,
  buttonSize = "medium",
  className = "",
  multiple = true,
  buttonText = "Chọn Fanpage",
  icon = <AddRoundedIcon />
}) => {
  const [open, setOpen] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [limit, setLimit] = useState(20);

  const handleOpen = () => {
    setSelected(Array.isArray(fanpageSelected) ? fanpageSelected : []); 
    setFiltered(listFanpages);
    setIsSearching(false);
    setLimit(20);
    setOpen(true);
  };

  const handleSearch = (term) => {
    const text = term.toLowerCase().trim();
    if (!text) {
      setFiltered(listFanpages);
      setIsSearching(false);
      setLimit(20);
      return;
    }
    const result = listFanpages.filter((f) => {
      const name = (f.name || f.fanpage_name || "").toLowerCase();
      return name.includes(text) || String(f.fanpage_id).includes(text);
    });
    setFiltered(result);
    setIsSearching(true);
    setLimit(20);
  };

  const handleToggle = (fanpage) => {
    const idStr = String(fanpage.fanpage_id);
    let newSelected;

    if (!multiple) {
      newSelected = [fanpage];
    } else {
      const isExist = selected.some((item) => String(item.fanpage_id) === idStr);
      if (!isExist) {
        newSelected = [...selected, fanpage];
      } else {
        newSelected = selected.filter((item) => String(item.fanpage_id) !== idStr);
      }
    }

    setSelected(newSelected);
    if (autoSave) handleChangeFanpage(newSelected);
  };

  const handleSelectAll = (e) => {
    if (!multiple) return;
    const isChecked = e.target.checked;
    const newSelected = isChecked ? [...listFanpages] : [];
    setSelected(newSelected);
    if (autoSave) handleChangeFanpage(newSelected);
  };

  const handleConfirm = () => {
    handleChangeFanpage(selected);
    setOpen(false);
  };

  const handleLoadMore = () => {
    setLimit((prev) => prev + 20);
  };

  return (
    <Box>
      <Button 
        startIcon={icon} 
        variant="contained" 
        onClick={handleOpen}
        size={buttonSize} 
        className={className}
      >
        {buttonText}
      </Button>

      <Dialog open={open} fullWidth maxWidth="md" onClose={() => setOpen(false)} disableEnforceFocus>
        <DialogTitle>
          <Box sx={{ mb: 1, fontWeight: 'bold' }}>
            Danh sách Fanpage
          </Box>
          <SearchFanpageForm onSearch={handleSearch} placeholder="Tìm kiếm fanpage..." />
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ minHeight: "400px" }}>
          <Box 
            sx={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              borderBottom: "1px dashed #ccc",
              mb: 2,
              pb: 1
            }}
          >
            <Box>
              {multiple && !isSearching && (
                <FormControlLabel
                  control={
                    <Checkbox 
                      checked={listFanpages.length > 0 && selected.length === listFanpages.length} 
                      onChange={handleSelectAll} 
                    />
                  }
                  label={<strong>Chọn tất cả ({listFanpages.length})</strong>}
                />
              )}
            </Box>
            
            <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
              Đã chọn: {selected.length}
            </Typography>
          </Box>

          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            {filtered.slice(0, limit).map((fanpage) => {
              const isChecked = selected.some(
                (item) => String(item.fanpage_id) === String(fanpage.fanpage_id)
              );

              return (
                <FormControlLabel
                  key={fanpage.fanpage_id}
                  control={
                    multiple ? (
                      <Checkbox 
                        checked={isChecked} 
                        onChange={() => handleToggle(fanpage)} 
                      />
                    ) : (
                      <Radio 
                        checked={isChecked} 
                        onChange={() => handleToggle(fanpage)} 
                      />
                    )
                  }
                  label={`${fanpage?.name || fanpage?.fanpage_name} (${fanpage.fanpage_id})`}
                />
              );
            })}
          </Box>

          {filtered.length > limit && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button 
                variant="outlined" 
                onClick={handleLoadMore}
                sx={{ borderRadius: '20px', textTransform: 'none' }}
              >
                Xem thêm ({filtered.length - limit} fanpage)
              </Button>
            </Box>
          )}

          {filtered.length === 0 && (
            <Typography align="center" sx={{ mt: 10 }} color="textSecondary">
              Không tìm thấy kết quả phù hợp
            </Typography>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpen(false)} variant="contained" color="inherit">Hủy</Button>
          <Button startIcon={<DoneIcon />} variant="contained" onClick={handleConfirm}>
            Xác nhận ({selected.length})
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DialogSelectFanpages;